// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input--checkbox[data-v-90ebca00] label{margin:0}.share-info-item[data-v-90ebca00]{-webkit-transition:all .2s ease-in;transition:all .2s ease-in}", ""]);
// Exports
module.exports = exports;
